export default __webpack_public_path__ + "static/media/addingCostcodes.5997ac84.svg";